import React, { useEffect, useState,useRef } from "react";
import { Button } from "../../components";
import localData from "../../localData";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { useLocation, Link } from "react-router-dom";
import FadeOnScreen from "../../utils/fadeOnScreen";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Validation from "../../utils/validation";

export default function Home() {
    const { sendEmail } = useGlobalContext();
    const { fade } = useGlobalContext().animations;

    const location = useLocation();

    const { kobo, seed, prive, lh, farms, mvx, contactUs } = localData.images;

    useEffect(() => FadeOnScreen.createObserver(), [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
        Validation.init();
    }, []);

    const { img1, img2, img3, img4, prolog, waves, work1, work2, work3, work4, work5, preloader } = localData.images;
    const { marketing, architecture, planning, development } = localData.svgs;

    const [gallery, setGallery] = useState([
        { background: work1 },
        { background: work2 },
        { background: work3 },
        { background: work4 },
        { background: work5 },
    ]);

    
    // SUBMIT
    const {createAlert} = useGlobalContext()

    const form = useRef(null);

    //

    return (
        <motion.main {...fade} className="home">
            <section className="about" data-lazy-block>
                <div className="image-group">
                    <img src={img1} alt="" className="img img-1" data-lazy="fade-down" />
                    <img src={img2} alt="" className="img img-2" data-lazy="fade-left" />
                    <img src={img3} alt="" className="img img-3" data-lazy="fade-up" />
                    <img src={img4} alt="" className="img img-4" data-lazy="fade-right" />
                </div>
                <div className="container ">
                    <div className="col"></div>
                    <div className="col">
                        <div className="prolog" data-lazy-block>
                            <h3 className="prolog-title">who we are</h3>
                            <img className="prolog-image" src={prolog} alt="" data-lazy="scale" />
                        </div>
                        <h2 className="about-title display-3">
                            We are a Full-Service Marketing Strategy and Advertising Consultancy.
                        </h2>
                        <div className="about-description">
                            At Mowida, we listen, learn and understand before we build. Together, we identify your
                            goals, help you find your ideal consumer, and thrive in a VUCA landscape. From strategic
                            marketing solutions to innovative product design & memorable campaigns, we help our clients
                            grow, innovate, transform.
                        </div>
                        <Link to="/contact">
                            <Button className="btn btn-outline-dark btn-lg">
                                <p>start a conversation</p>
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>

            <section className="what-we-do">
                <img className="what-we-do-cover" src={waves} alt="" />

                <div className="container">
                    <div className="prolog" data-lazy-block>
                        <h3 className="prolog-title">what we do</h3>
                        <img className="prolog-image" src={prolog} alt="" data-lazy="scale" />
                    </div>
                    <div className="what-we-do-center">
                        <div className="info">
                            <h2 className="what-we-do-title display-2">Our Approach</h2>
                            <Link to="/what-we-do">
                                <h3 className="what-we-do-subtitle display-3">
                                    True Advertising is based on finding the ideal customer.
                                </h3>
                            </Link>
                            <p className="what-we-do-description">
                                We get it. You are not here to hear about us, you want to know what we can do for your
                                business. It’s difficult finding the right marketing agency willing to go the extra mile
                                to understand your market and create solutions tailor made for your business needs.
                            </p>
                            <Link to="/contact">
                                <Button className="btn btn-lg btn-light">
                                    <p>WORK WITH EXPERTS</p>
                                </Button>
                            </Link>
                        </div>
                        <div className="card-group">
                            <div className="wrapper" data-lazy-block>
                                <Link to="/what-we-do" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{marketing}</div>
                                    <h4 className="card-title">Integrated Marketing Strategy and Planning</h4>
                                    <div className="card-description">
                                        Based on our market research, we help you analyse your competitors, design your
                                        business strategy, capabilities, processes and metrics.{" "}
                                    </div>
                                </Link>
                            </div>
                            <div className="wrapper" data-lazy-block>
                                <Link to="/what-we-do" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{architecture}</div>
                                    <h4 className="card-title">Brand Architecture and Identity Development</h4>
                                    <div className="card-description">
                                        Just like every building needs a foundation, every business a brand
                                        architecture. Are you a new business or looking to rebrand, we provide clarity.
                                    </div>
                                </Link>
                            </div>
                            <div className="wrapper" data-lazy-block>
                                <Link to="/what-we-do" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{planning}</div>
                                    <h4 className="card-title">Campaign Planning and Execution</h4>
                                    <div className="card-description">
                                        Great campaigns are inspired by powerful consumer insights.
                                    </div>
                                </Link>
                            </div>
                            <div className="wrapper" data-lazy-block>
                                <Link to="/what-we-do" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{development}</div>
                                    <h4 className="card-title">Web Development</h4>
                                    <div className="card-description">
                                        We take a strategic approach to website design. We focus on communicating your
                                        value proposition with clear messaging and out of the box design
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sponsors" data-lazy-block>
                <div className="container-1050">
                    <div className="sponsors-center">
                        <div className="item">
                            <img className="kobo" src={kobo} alt="" />
                        </div>
                        <div className="item">
                            <img src={mvx} alt="" />
                        </div>
                        <div className="item">
                            <img src={farms} alt="" />
                        </div>
                        <div className="item">
                            <img src={lh} alt="" />
                        </div>
                        <div className="item">
                            <img src={prive} alt="" />
                        </div>
                        <div className="item">
                            <img className="seed" src={seed} alt="" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="works" data-lazy-block>
                <div className="container">
                    <div className="wrapper">
                        <div className="prolog" data-lazy-block>
                            <h3 className="prolog-title">our works</h3>
                            <img className="prolog-image" src={prolog} alt="" data-lazy="scale" />
                        </div>
                        <h3 className="works-title display-3">
                            We are a Result Driven Strategy, Design, Digital, and Media Consult.
                        </h3>
                    </div>

                    {!gallery || !Object.keys(gallery).length ? (
                        <img src={preloader} width="300" />
                    ) : (
                        <div className="swiper-custom-wrapper">
                            <Swiper
                                touchStartPreventDefault={false}
                                // loop={true}
                                modules={[Navigation, Pagination, Autoplay]}
                                slidesPerView={1}
                                spaceBetween={35}
                                breakpoints={{
                                    // when window width is >= 640px
                                    768: {
                                        //   width: 640,
                                        slidesPerView: 2,
                                        spaceBetween: 60,
                                    },
                                    // when window width is >= 768px
                                    992: {
                                        //   width: 768,
                                        slidesPerView: 3.4,
                                        spaceBetween: 60,
                                    },
                                    // 992: {
                                    //     slidesPerView: 3,
                                    // },
                                }}
                                autoplay={{
                                    delay: 4500,
                                    disableOnInteraction: false,
                                }}
                                speed={1500}
                                // pagination={{ clickable: true }}
                            >
                                {gallery.map((item, index) => {
                                    return (
                                        <SwiperSlide key={index}>
                                            <Link to="/works" className="link" data-lazy="fade">
                                                <img className="" src={item.background} alt="" />
                                            </Link>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div>
                    )}
                </div>
            </section>

            <section className="contact" id="contact">
                <div className="container">
                    <div className="wrapper">
                        <div className="prolog" data-lazy-block>
                            <h3 className="prolog-title">speak to an expert</h3>
                            <img className="prolog-image" src={prolog} alt="" data-lazy="scale" />
                        </div>
                    </div>
                    <div className="contact-center" data-lazy-block>
                        <div className="contact-cover" data-lazy="fade-left">
                            <img src={contactUs} alt="" />
                        </div>
                        <form
                            className="form contact-form needs-validation"
                            noValidate
                            ref={form}
                            onSubmit={(e) => sendEmail(form,e)}
                        >
                            <div className="form-inner">
                                <h2 className="contact-title display-3">
                                    What keeps you up at night?
                                    <br /> Talk to us
                                </h2>
                                <h6 className="contact-subtitle">Speak to an expert today</h6>
                                <div className="input-group">
                                    <input type="text" className="form-control" required name="from_name" placeholder=" " />
                                    <label className="form-label">name</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">name is required.</div>
                                </div>
                                <div className="input-group">
                                    <input type="email" required className="form-control" name="from_email" placeholder=" " />
                                    <label className="form-label">email</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">email is required.</div>
                                </div>
                                <div className="input-group">
                                    <input type="text" className="form-control" name="from_telephone" placeholder=" " />
                                    <label className="form-label">telephone</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">telephone is required.</div>
                                </div>
                                <div className="input-group">
                                    <textarea  id="" cols="30" rows="3" required name="from_message" className="form-control" placeholder=" "></textarea>
                                    <label className="form-label">message</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">message is required.</div>
                                </div>

                                <input type="text" name="to_name" defaultValue="Funmi" style={{ display: "none" }} />
                                <input
                                    type="text"
                                    name="text"
                                    defaultValue="You got a new message from"
                                    style={{ display: "none" }}
                                />

                                <button type="submit" className="btn btn-xl btn-danger">
                                    <span>Submit</span>
                                </button>
                                <p>or</p>
                                <div className="form-links">
                                    <a href="tel:08085370831" className="link-primary" underline="hover">
                                        08085370831
                                    </a>
                                    <a
                                        href="mailto:mowidadigital@gmail.com"
                                        className="link-primary"
                                        underline="hover"
                                        target="_blank"
                                    >
                                        mowidadigital@gmail.com
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
